import router from '@/router'
import axios from 'axios'
// import iView from 'iview'
import { Message } from 'element-ui';
import { baseUrl } from '@/config/deployUrl'
import AES from "@/libs/AES.js";
// 配置API接口地址

export let baseURL = baseUrl

// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
      if (o[key].length === 0) {
        delete o[key]
      }
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
      if (o[key].length === 0) {
        delete o[key]
      }
    }
  }
  return o
}

// axios 全局变量 //
// axios.defaults.baseURL = baseUrl
// axios.defaults.timeout = 5000
// axios.defaults.withCredentials = true // 让ajax携带cookie

// 请求拦截器
axios.interceptors.request.use(function (config) {
  // let initParams = session.parseJSON()
  // config.headers.common['authorization-token'] = initParams === null ? '' : initParams
  config.headers.post['Content-Type'] = 'application/json'
  return config
}, function (error) {
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(function (response) {
  //   let status = response.data.status
  // console.log("解密")
  // console.log(AES.decrypt(response.data))
  // console.log(response)
  // let loadding = Vue.prototype.$loading({ fullscreen: true })
  let _data = JSON.parse(AES.decrypt(response.data))
  // console.log("请求")
  // console.log(_data)
  let code = _data.code
  if (code == 200) {
    // router.push('/login')
    return _data.data
  }else if(code == 0){
    Message.error(_data.msg)
    router.push('/login')
  }else if(code == 100){
    Message.error("登录失败")
    router.push('/login')
  }else if(code == 608){
    Message.error(_data.msg)
    router.push('/login')
  }else{
    Message.error(_data.msg)
    return _data.data
  }
}, function (error) {
  // console.log(error)
  let errmsg = '系统错误'
  Message.error(errmsg)
  return Promise.reject(error)
})
/**
 * 定义 get post 请求
 */
// var CancelToken = axios.CancelToken;
// var source = CancelToken.source();

// axios.get('/user/12345', {
//   cancelToken: source.token
// }).catch(function (thrown) {
//   if (axios.isCancel(thrown)) {
//     console.log('Request canceled', thrown.message);
//   } else {
//     // handle error
//   }
// });
// cancel the request (the message parameter is optional)
// source.cancel('Operation canceled by the user.');
export const request = {
  // deleteFile: function (url, data) {
  //   let config = {
  //     baseURL: 'http://develop.clianmeng.cn/njwd_image/',
  //     method: 'get',
  //     url: url,
  //     params: data || {/* get请求参数 */}
  //   }
  //   return axios(config)
  // },
  get: function (url, data, tempUrl) {
    if (data) {
      data = filterNull(data)
    }
    let config = {
      baseURL: tempUrl || baseURL,
      method: 'get',
      url: url,
      params: data || {/* get请求参数 */ }
    }
    return axios(config)
  },
  post: function (url, data, responseType, tempUrl) {
    // console.log("请求")
    // console.log(data)
    if (data) {
      data = filterNull(data)
    }
    // console.log(data)
    let config = {
      baseURL: tempUrl || baseURL,
      method: 'post',
      url: url,
      responseType: responseType || '', // 为了导出excel设置
      data: AES.encrypt(JSON.stringify(data)) || {/* post请求参数 */ }
    }
    return axios(config)
  },
  put: function (url, data, responseType, tempUrl) {
    if (data) {
      data = filterNull(data)
    }
    let config = {
      baseURL: tempUrl || baseURL,
      method: 'put',
      url: url,
      responseType: responseType || '', // 为了导出excel设置
      data: data || {/* post请求参数 */ }
    }
    return axios(config)
  },
  delete: function (url, data, tempUrl) {
    if (data) {
      data = filterNull(data)
    }
    let config = {
      baseURL: tempUrl || baseURL,
      method: 'delete',
      url: url,
      data: data || {/* get请求参数 */ }
    }
    return axios(config)
  },
  multipleRequest: function (requests) {
    let reqArray = []
    if (requests.length > 0) {
      for (let req of requests) {
        if (req.method === 'GET') {
          reqArray.push(axios.get(baseURL + req.url, { params: req.data }))
        } else if (req.method === 'POST') {
          reqArray.push(axios.post(baseURL + req.url, req.data))
        }
      }
      return axios.all(reqArray)
    }
  }
}
